import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Avatar, Divider } from "@mui/material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import PageHeader from "./../../components/PageHeader";
import AnalyticsCard from "../../components/AnalyticsCard";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import PlaylistPlayIcon from "@mui/icons-material/PlaylistPlay";
import SortIcon from "@mui/icons-material/Sort";
import { Chat } from "react-iconly";
import { Images } from "../../assets/common";
import AnalyticsStats from "../../components/AnalyticsStats";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

export default function Analytics() {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [lifeTimeCount, setLifetimeCount] = useState({});
  const [musicAnalytics, setMusicAnalytics] = useState([]);
  const history = useHistory();

  const getMusicAnalytics = async () => {
    try {
      setLoading(true);
      const response = await ApiService.MUSIC_ANALYTICS();
      setMusicAnalytics([...response["result"]["musicArray"]]);
      setLifetimeCount({ ...response["result"]["lifetimeCounts"] });
      // console.log(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    getMusicAnalytics();
    return function () {
      setMusicAnalytics([]);
    };
  }, []);
  return (
    <Box>
      <Box className="__player_on_pading">
        <PageHeader />
        {/* <Box
          sx={{
            color: "#999999",
            display: "flex",
            alignItems: "center",
            padding: "0 20px 20px",
          }}
          className="_cp fs-14"
          onClick={() => history.goBack()}
          // onClick={sssssss ? history.goBack() : history.push("/app/Analytics")}
        >
          <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} /> Back
        </Box> */}
        <Typography
          // className="web_header"
          style={{
            padding: "20px 0 5px 0",
            borderBottom: "1px solid #262626 ",
            fontSize: "20px",
          }}
        >
          {t("analytics.header.header1")}
        </Typography>
        <Typography className=" fs-14 fade-text" style={{ paddingTop: "20px" }}>
          {t("analytics.header.header2")}
        </Typography>
        <Box className="grid" sx={{ marginTop: "5px" }}>
          {/* <AnalyticsCard
            className={"_cp"}
            type={"Views"}
            name={t("analytics.card.card1")}
            count={lifeTimeCount["lifetimeViews"]}
            icon={Images.white_views}
          /> */}

          <AnalyticsCard
            type={"Tips"}
            name={t("analytics.card.card2")}
            count={lifeTimeCount["lifeTimeTip"]?.toFixed(2)}
            icon={Images.white_tip}
          />

          <AnalyticsCard
            type={"Streams"}
            name={t("analytics.card.card3")}
            count={lifeTimeCount["lifeTimeListens"]}
            icon={Images.white_stream}
          />

          <AnalyticsCard
            type={"Follow"}
            name={t("analytics.card.card4")}
            count={lifeTimeCount["lifeTimeFollowers"]}
            icon={Images.white_follow}
          />
        </Box>
        <Typography
          className="fs-14 fade-text"
          sx={{ margin: "20px 0 38px 0" }}
        >
          {t("analytics.header.header3")}
        </Typography>
        <Stack spacing={2}>
          {musicAnalytics &&
            musicAnalytics.map((music, index) => (
              <AnalyticsStats
                key={index}
                music={music}
                onClick={() =>
                  history.push(
                    `/app/LifetimeCount/Tips/${music["title"]}/${music["_id"]}`
                  )
                }
              />
            ))}
        </Stack>
      </Box>
      {loading ? <Loader /> : null}
    </Box>
  );
}
